import {Component, h, Prop, Element, Watch} from '@stencil/core';
import {sanitizeHTML} from '../utils';

@Component({
  tag: 'list-row-type',
  styleUrl: 'list-row-type.scss',
  shadow: false
})
export class ListRowType {
    @Prop({mutable: true}) value: string | string[];
    @Element() hostElement: HTMLElement;
    private items: string[] = [];

    componentWillLoad() {
        if (typeof this.value === 'string') {
          try {
            this.value = JSON.parse(this.value);
          } catch (error) {
          }
        }
        this.items = this.parseValueToList(this.value);
    }

    private parseValueToList(value) {
        if (!Array.isArray(value)) {
          return [value];
        }
        return value.map(item => item.trim());
    }

    @Watch('value')
    valueChanged(newValue: string | string[]) {
        const parsedValue = (typeof newValue === 'string')
          ? this.tryParseJSON(newValue, newValue)
          : newValue;

        this.items = this.parseValueToList(parsedValue);
    }

    private tryParseJSON(jsonString: string, fallbackValue: any): any {//eslint-disable-line @typescript-eslint/no-explicit-any
        try {
          return JSON.parse(jsonString);
        } catch (error) {
          return fallbackValue;
        }
    }


    render() {
        if (this.items.length === 1) {
          return (
            <p innerHTML={sanitizeHTML(this.items[0])}></p>
          );
        } else {
          return (
            <ul>
              {this.items.map(item => <li innerHTML={sanitizeHTML(item)}></li>)}
            </ul>
          );
        }
    }
}
